import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=1d63b506&scoped=true&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/login.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d63b506",
  null
  
)

export default component.exports